import {
	setMeta,
	checkRule
} from '@/router/middleware'
import routerView from '@/views/v2.commissions/routerView'


const List = () => import('@/views/v2.commissions/List')
const Default = () => import('@/views/v2.commissions/Default')
const Groups = () => import('@/views/v2.commissions/Groups')
const Categories = () => import('@/views/v2.commissions/Categories')
const Products = () => import('@/views/v2.commissions/Products')
const Tiers = () => import('@/views/v2.commissions/Tiers')
const Rules = () => import('@/views/v2.commissions/Rules')


export default {
	path: 'stores/:store_id?/v2.commissions',
	redirect: '',
	component: routerView,
	children: [
		{
			path: '',
			name: 'v2.commissions',
			component: List,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.plural',
			}
		},
		{
			path: 'default',
			name: 'v2.commissions.default',
			component: Default,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.models.default._',
			}
		},
		{
			path: 'groups',
			name: 'v2.commissions.groups',
			component: Groups,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.models.group._',
			}
		},
		{
			path: 'categories',
			name: 'v2.commissions.categories',
			component: Categories,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.models.category_base._',
			}
		},
		{
			path: 'products',
			name: 'v2.commissions.products',
			component: Products,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.models.product_base._',
			}
		},
		{
			path: 'tiers',
			name: 'v2.commissions.tiers',
			component: Tiers,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.models.transaction_tier._',
			}
		},
		{
			path: 'rules',
			name: 'v2.commissions.rules',
			component: Rules,
			meta: {
				middleware: [setMeta, checkRule],
				labelTrans: 'v2commission.group._',
			}
		},
	]
}